// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asd__wrapper--full-screen[data-v-10addb4f]{z-index:9999}.asd__day-button[data-v-10addb4f]{pointer-events:none}.asd__day[data-v-10addb4f],.asd__day--disabled[data-v-10addb4f],.asd__day--empty[data-v-10addb4f]{opacity:1!important}", ""]);
// Exports
module.exports = exports;
